/*
 * @Description:
 * @Date: 2025-06-17 18:58:15
 */
import { useIntervalFn } from '@vueuse/core';
import { onMounted, onUnmounted, ref, computed } from 'vue';

export default () => {
  const T = 60;
  const time = ref(T);

  const text = computed(() => (time.value === T ? '获取验证码' : time.value));
  const disabled = computed(() => time.value !== T);

  const { pause, resume } = useIntervalFn(
    () => {
      time.value--;
      if (time.value <= 0) {
        pause(); // 暂停倒计时
        time.value = T;
      }
    },
    1000,
    { immediate: true }
  );
  const start = () => {
    if (time.value !== T) return;
    time.value--;
    resume();
  };
  const stop = () => {
    pause();
    time.value = T;
  };

  onMounted(() => {
    pause();
  });
  onUnmounted(() => {
    pause();
  });

  return { time, start, disabled, text, stop };
};
